var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.958 7.125C13.958 10.7305 11.0381 13.625 7.45801 13.625C3.85254 13.625 0.958008 10.7305 0.958008 7.125C0.958008 5.7793 1.36426 4.53516 2.0752 3.49414C2.20215 3.29102 2.45605 3.24023 2.63379 3.36719C2.81152 3.49414 2.8623 3.74805 2.73535 3.95117C2.12598 4.86523 1.77051 5.95703 1.77051 7.125C1.77051 10.2734 4.30957 12.8125 7.45801 12.8125C10.5811 12.8125 13.1455 10.2734 13.1455 7.125C13.1455 4.12891 10.8096 1.66602 7.86426 1.46289V3.46875C7.86426 3.69727 7.66113 3.875 7.45801 3.875C7.22949 3.875 7.05176 3.69727 7.05176 3.46875V1.03125C7.05176 0.828125 7.22949 0.625 7.45801 0.625C11.0381 0.625 13.958 3.54492 13.958 7.125ZM7.7373 6.8457C7.88965 6.99805 7.88965 7.27734 7.7373 7.42969C7.58496 7.58203 7.30566 7.58203 7.15332 7.42969L4.71582 4.99219C4.56348 4.83984 4.56348 4.56055 4.71582 4.4082C4.86816 4.25586 5.14746 4.25586 5.2998 4.4082L7.7373 6.8457Z",
    fill: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpire);
export default __webpack_public_path__ + "static/media/expire.a2b2ae8d.svg";
export { ForwardRef as ReactComponent };